export default __webpack_public_path__ + "static/englet-2-f963b25ed616292d5cb2b3ca55945aa7.jpg";